import _ from 'lodash-es';
import tenantLocalStorage from './TenantLocalStorage';

// layout的远程存储Api
export type RemotePersistApi = (
  scope: string,
  path: string[],
  data: string | undefined
) => Promise<any>;

let remotePersistApi: RemotePersistApi | undefined;

export function setRemotePersistApi(api: RemotePersistApi) {
  remotePersistApi = api;
}

export function getRemotePersistApi() {
  return remotePersistApi;
}

// 读取布局
export function getLayout<T>(
  scope: string,
  path: string[],
  def?: any,
  check?: (v: T) => boolean
): T {
  const key = [scope, ...path].join('~');
  const value = tenantLocalStorage.getItem(key);
  if (!value) {
    return def;
  }

  const data = JSON.parse(value);
  if (check) {
    try {
      if (!check(data)) {
        return def;
      }
    } catch (e) {
      return def;
    }
  }

  return data;
}

export function saveLayout(scope: string, path: string[], data: any) {
  const key = [scope, ...path].join('~');
  const value = JSON.stringify(data);
  tenantLocalStorage.setItem(key, value);

  // 更新远程服务器
  remotePersistApi?.(scope, path, value);
}

export function deleteLayout(scope: string, path: string[]) {
  const key = [scope, ...path].join('~');
  tenantLocalStorage.removeItem(key);

  // 更新远程服务器
  remotePersistApi?.(scope, path, undefined);
}

interface DataOperator<D> {
  id: (data: D) => string;
  pinned: (data: D) => boolean | 'left' | 'right' | null | undefined; // 固定不可动
  isShow: (data: D) => boolean; // 是否显示
  setShow: (data: D, show: boolean, pd: any) => void;
}

// 将保存的配置，与当前存在的配置融合
export function mergeLayout<D>(
  persistDatas: { id: string; show: boolean }[],
  datas: D[],
  operator: DataOperator<D>
) {
  let prevId: string | undefined;

  const leftPinned: D[] = [];
  const middle: D[] = [];
  const rightPinned: D[] = [];

  for (const data of datas) {
    const id = operator.id(data);
    const pinned = operator.pinned(data);

    if (pinned) {
      // 固定列不可设置
      if (pinned == 'right') {
        rightPinned.push(data);
      } else {
        leftPinned.push(data);
      }

      _.remove(persistDatas, (e) => e.id == id);
      continue;
    }

    // vnode是comment
    if ((data as any).type && _.isSymbol((data as any).type)) {
      continue;
    }

    middle.push(data);

    const p = _.find(persistDatas, (e) => e.id == id);
    if (p) {
      operator.setShow(data, p.show, p);
      prevId = id;
    } else {
      // 新增列
      if (prevId) {
        const i = _.findIndex(persistDatas, (e) => e.id == prevId);
        if (i >= 0) {
          // 在中间插入
          persistDatas.splice(i + 1, 0, { id, show: operator.isShow(data) });
          continue;
        }
      }

      persistDatas.push({ id, show: operator.isShow(data) });
      prevId = undefined;
    }
  }

  // 执行排序
  const sorted = _.sortBy(middle, (d) => {
    const id = operator.id(d);
    return _.findIndex(persistDatas, (x) => x.id == id);
  });

  return [...leftPinned, ...sorted, ...rightPinned];
}
